export default {
    title: 'Importted users',
    next: 'Close',
    nodata: 'Unfortunately, no users could be imported successfully.'
}
